import {
  CUSTOM_PRIVATE_SHARE_CARD_META,
  CUSTOM_PRIVATE_SHARE_CARD_TITLE,
  CUSTOM_PRIVATE_SHARE_TEXT,
  CUSTOM_STYLE_GRID_5,
  CUSTOM_ZOOM_BOUNDS,
} from '../constants/games/zoomedInCustomGame';
import { createDailyPrivateShareCardBlob } from './dailyPrivateShareCard';
import { buildStatusRows } from './wordleShare';

const GRID_COLUMNS = 5;
const REVEALED_STATUSES = new Set(['correct', 'present', 'absent']);

const normalizeStatusCell = (value) => {
  const normalized = String(value || '').toLowerCase();
  return REVEALED_STATUSES.has(normalized) ? normalized : null;
};

const normalizeServerStatusRow = (statuses = [], columns = GRID_COLUMNS) =>
  Array.from({ length: columns }, (_, index) => normalizeStatusCell(statuses?.[index]));

const toGuessWords = (guesses = []) =>
  (Array.isArray(guesses) ? guesses : [])
    .map((entry) => String(entry?.word || '').trim().toUpperCase())
    .filter(Boolean);

const buildStatusRowsForCustom = ({ guesses = [], solution = '', maxGuesses = 6 }) => {
  const guessWords = toGuessWords(guesses);
  const resolvedMaxGuesses = Math.max(1, Number(maxGuesses) || 1);
  if (guessWords.length === 0) return [];

  const fallbackRows = buildStatusRows({ guesses: guessWords, solution });

  return guessWords.slice(0, resolvedMaxGuesses).map((_, index) => {
    const serverStatuses = normalizeServerStatusRow(guesses?.[index]?.letterStatuses, GRID_COLUMNS);
    const hasServerStatuses = serverStatuses.some((status) => status !== null);
    if (hasServerStatuses) return serverStatuses;
    return normalizeServerStatusRow(fallbackRows?.[index], GRID_COLUMNS);
  });
};

export async function createCustomPrivateShareCardBlob({
  imageUrl,
  guesses = [],
  solution = '',
  zoomLevel = 100,
  zoomOrigin = null,
  includeGuessGrid = true,
  neutralGuessColors = false,
  maxGuesses = 6,
  style = CUSTOM_STYLE_GRID_5,
} = {}) {
  const guessWords = toGuessWords(guesses);
  const resolvedMaxGuesses = Math.max(1, Number(maxGuesses) || guessWords.length || 1);
  const isGridStyle = String(style || '') === CUSTOM_STYLE_GRID_5;
  const shouldRenderGuessGrid = isGridStyle && includeGuessGrid !== false;
  const statusRows = shouldRenderGuessGrid
    ? buildStatusRowsForCustom({ guesses, solution, maxGuesses: resolvedMaxGuesses })
    : [];

  return createDailyPrivateShareCardBlob({
    imageUrl,
    guesses: guessWords,
    solution,
    zoomLevel,
    zoomOrigin,
    includeGuessGrid: shouldRenderGuessGrid,
    neutralGuessColors,
    maxGuesses: resolvedMaxGuesses,
    zoomBounds: CUSTOM_ZOOM_BOUNDS,
    titleText: CUSTOM_PRIVATE_SHARE_CARD_TITLE,
    metaText: CUSTOM_PRIVATE_SHARE_CARD_META,
    siteText: CUSTOM_PRIVATE_SHARE_TEXT,
    statusRowsOverride: shouldRenderGuessGrid ? statusRows : null,
    gridColumns: GRID_COLUMNS,
  });
}
